import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DeviceGridComponent} from './containers/device-grid/device-grid.component';
import {DeviceSelectionComponent} from './components/device-selection/device-selection.component';
import {SensorComponentComponent} from './components/sensor-component/sensor-component.component';
import {NotiBellComponent} from './components/noti-bell/noti-bell.component';
import {reducers} from './reducers';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {DeviceGridViewEffects} from './effects/device-grid-view.effects';
import {SharedModule} from '../shared';
import {IconModule} from '../vision/icon';
import {ScoreToConditionPipe} from '../shared/pipes/score-to-condition.pipe';
import {DeviceNuggetComponent} from './components/device-nugget/device-nugget.component';
import {Dropdown2Module} from '../vision/dropdown2';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    IconModule,
    Dropdown2Module,
    StoreModule.forFeature('device-grid', reducers),
    EffectsModule.forFeature([
      DeviceGridViewEffects
    ])
  ],
  exports: [
    DeviceGridComponent
  ],
  declarations: [
    DeviceGridComponent,
    DeviceSelectionComponent,
    SensorComponentComponent,
    NotiBellComponent,
    DeviceNuggetComponent
  ],
  providers: [
    ScoreToConditionPipe
  ]
})

export class DeviceGridModule {
}
